// src/utils/attachAuthGuards.js
import api from "../shared/api/apiClient";
import { logout } from "../shared/lib/auth/authHelper";
import appConfig from "../config/appConfig";

const OVERRIDE_EXP_KEY = "session-exp-ms";

let interceptorId = null;

export function attachAuthGuards() {
  if (interceptorId !== null) return;

  interceptorId = api.interceptors.response.use(
    (res) => res,
    (err) => {
      const status = err?.response?.status;
      const url = err?.config?.url || "";

      const isRefreshRequest =
        url === "/auth/refresh" || url.endsWith("/auth/refresh");

      if (status === 401 && !isRefreshRequest) {
        localStorage.removeItem(OVERRIDE_EXP_KEY);
        logout();

        const loginPath = appConfig.LOGIN_PATH || "/";
        window.location.assign(`${loginPath}?reason=401`);
      }

      return Promise.reject(err);
    }
  );
}

export function detachAuthGuards() {
  if (interceptorId !== null) {
    api.interceptors.response.eject(interceptorId);
    interceptorId = null;
  }
}